var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyesight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.61 93.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1e3e80;}.cls-3{fill:#59ac31;stroke:#59ac31;stroke-width:4.03px;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-5{stroke-miterlimit:10;stroke-width:2.28px;}.cls-5,.cls-4{fill:none;stroke:#1e3e80;}.cls-5,.cls-4,.cls-2{fill-rule:evenodd;}.cls-4{stroke-width:2.98px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.34,38.66l-16.44,16.76c-1.12-1.82-1.76-3.97-1.76-6.27,0-6.71,5.43-12.14,12.12-12.14,2.22,0,4.31,.6,6.09,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.31,57.11l14.97-15.26c1.02,1.66,1.6,3.61,1.6,5.71,0,6.11-4.94,11.05-11.03,11.05-2.02,0-3.92-.55-5.54-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.94,38.64l7.97,9.17s-5.3,7.12-8.17,10.51-10.8,13.65-31.9,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.22,66.53c-5.26-2.92-8.08-6.48-9.54-8.21-2.87-3.39-8.17-10.51-8.17-10.51l7.97-9.17s7.94-11.27,19.54-13.02c11.61-1.75,17.37,.36,25.55,5.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.5,
    y1: 79.88,
    x2: 81.51,
    y2: 15.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.13,8.81c.41,.51,.46,1.26,.06,1.82-.48,.68-1.42,.84-2.1,.36C56.16-.25,34.44,.46,19.27,12.73,.48,27.92-2.45,55.56,12.74,74.35c15.19,18.79,42.83,21.72,61.62,6.53,14.89-12.04,20.27-32.83,13.06-50.55-.31-.77,.06-1.65,.83-1.97,.77-.31,1.65,.04,1.97,.83,7.7,18.95,1.96,41.17-13.96,54.04-20.08,16.24-49.63,13.11-65.87-6.98C-5.84,56.16-2.71,26.62,17.37,10.38c16.22-13.11,39.43-13.88,56.45-1.86,.12,.08,.22,.18,.3,.28Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesight);
export default __webpack_public_path__ + "static/media/Eyesight.b025d7e6e5dd76b2b834d166051d433b.svg";
export { ForwardRef as ReactComponent };